import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const BlueBonusActivitySubscribers: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="BlueBonusActivitySubscribers"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <path
            d="M47.8929 18.6348C49.2024 20.903 49.2024 23.6974 47.8929 25.9656L39.5583 40.4016C38.2487 42.6697 35.8287 44.0669 33.2096 44.0669H16.5404C13.9214 44.0669 11.5013 42.6697 10.1918 40.4016L1.85714 25.9656C0.547621 23.6974 0.547621 20.903 1.85714 18.6348L10.1918 4.19883C11.5013 1.93068 13.9214 0.533447 16.5404 0.533447H33.2096C35.8287 0.533447 38.2487 1.93068 39.5582 4.19883L47.8929 18.6348Z"
            fill="#6A88FF"
          />
          <path
            d="M43.6128 18.8362C44.6788 20.6826 44.6788 22.9575 43.6128 24.8039L36.8279 36.5556C35.7619 38.4021 33.7918 39.5395 31.6597 39.5395H18.09C15.9579 39.5395 13.9878 38.4021 12.9218 36.5556L6.13692 24.8039C5.0709 22.9575 5.0709 20.6826 6.13692 18.8362L12.9218 7.08443C13.9878 5.23802 15.9579 4.10059 18.09 4.10059H31.6597C33.7918 4.10059 35.7619 5.23802 36.8279 7.08443L43.6128 18.8362Z"
            fill="black"
          />
          <path
            d="M43.6127 20.7263C44.6787 22.5025 44.6787 24.6908 43.6127 26.4671L36.8278 37.772C35.7618 39.5482 33.7917 40.6424 31.6597 40.6424H18.0899C15.9579 40.6424 13.9878 39.5482 12.9218 37.772L6.13692 26.4671C5.0709 24.6908 5.0709 22.5025 6.13692 20.7263L12.9218 9.4213C13.9878 7.64509 15.9579 6.5509 18.0899 6.5509H31.6597C33.7917 6.5509 35.7618 7.64509 36.8278 9.4213L43.6127 20.7263Z"
            fill="#6A88FF"
          />
          <path
            d="M15.5146 8.5509C15.5146 7.44633 16.4101 6.5509 17.5146 6.5509H32.1763C33.2808 6.5509 34.1763 7.44633 34.1763 8.5509V31.1199C34.1763 31.9123 33.2986 32.3899 32.6332 31.9596L25.3876 27.2733C25.0571 27.0595 24.6319 27.0595 24.3014 27.2733L17.0578 31.9593C16.3925 32.3898 15.5146 31.9122 15.5146 31.1197V8.5509Z"
            fill="white"
          />
          <path
            d="M24.8457 8.99475V20.4457"
            stroke="#6A88FF"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M18.001 6.5509V27.1746C18.001 27.5645 18.4275 27.8044 18.7607 27.6018L24.6528 24.0195C24.8131 23.9221 25.0146 23.9226 25.1744 24.0209L30.9866 27.5952C31.3198 27.8 31.7485 27.5604 31.7485 27.1693V6.5509"
            stroke="#6A88FF"
            strokeWidth="1.5"
          />
          <path
            d="M24.1819 36.2012C24.1819 36.2012 23.9567 36.1261 23.6439 36.0219C22.565 35.6623 21.7061 34.8034 21.3464 33.7245C21.2422 33.4116 21.1671 33.1864 21.1671 33.1864C21.1215 33.0498 20.9936 32.9576 20.8496 32.9576C20.7056 32.9576 20.5777 33.0498 20.5321 33.1864C20.5321 33.1864 20.457 33.4116 20.3529 33.7244C19.9932 34.8034 19.1343 35.6623 18.0554 36.0219C17.7425 36.1261 17.5173 36.2012 17.5173 36.2012C17.3807 36.2468 17.2886 36.3747 17.2886 36.5187C17.2886 36.6628 17.3807 36.7906 17.5174 36.8362C17.5174 36.8362 17.7426 36.9113 18.0553 37.0155C19.1343 37.3751 19.9932 38.234 20.3529 39.3129C20.457 39.6258 20.5321 39.851 20.5321 39.851C20.5777 39.9876 20.7056 40.0798 20.8496 40.0798C20.9936 40.0798 21.1216 39.9876 21.1671 39.851C21.1671 39.851 21.2423 39.6258 21.3464 39.313C21.7061 38.234 22.565 37.3751 23.6439 37.0155C23.9567 36.9113 24.1819 36.8362 24.1819 36.8362C24.3185 36.7906 24.4107 36.6628 24.4107 36.5187C24.4107 36.3747 24.3185 36.2468 24.1819 36.2012Z"
            fill="white"
          />
          <path
            d="M32.2322 36.2012C32.2322 36.2012 32.007 36.1261 31.6942 36.0219C30.6153 35.6623 29.7563 34.8034 29.3967 33.7245C29.2925 33.4116 29.2174 33.1864 29.2174 33.1864C29.1718 33.0498 29.0439 32.9576 28.8999 32.9576C28.7559 32.9576 28.628 33.0498 28.5824 33.1864C28.5824 33.1864 28.5073 33.4116 28.4032 33.7244C28.0435 34.8034 27.1846 35.6623 26.1057 36.0219C25.7928 36.1261 25.5676 36.2012 25.5676 36.2012C25.431 36.2468 25.3389 36.3747 25.3389 36.5187C25.3389 36.6628 25.431 36.7906 25.5677 36.8362C25.5677 36.8362 25.7929 36.9113 26.1056 37.0155C27.1846 37.3751 28.0435 38.234 28.4031 39.3129C28.5073 39.6258 28.5824 39.851 28.5824 39.851C28.628 39.9876 28.7559 40.0798 28.8999 40.0798C29.0439 40.0798 29.1719 39.9876 29.2174 39.851C29.2174 39.851 29.2926 39.6258 29.3967 39.313C29.7564 38.234 30.6153 37.3751 31.6942 37.0155C32.007 36.9113 32.2322 36.8362 32.2322 36.8362C32.3688 36.7906 32.461 36.6628 32.461 36.5187C32.461 36.3747 32.3688 36.2468 32.2322 36.2012Z"
            fill="white"
          />
        </svg>
      }
      {...restProps}
    />
  );
};

export default BlueBonusActivitySubscribers;
